<template>
    <div
        class="offcanvas offcanvas-end"
        tabindex="-1"
        id="offcanvasDetailBoth"
        aria-labelledby="offcanvasAddUserLabel"
    >
        <div class="offcanvas-header border-bottom">
            <h5 id="offcanvasAddUserLabel" class="offcanvas-title">
                DETAIL SARANA
            </h5>
            <button
                type="button"
                id="dismisBtn"
                class="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
            ></button>
        </div>
        <div class="offcanvas-body mx-0 flex-grow-0 p-6 h-100">
            <div class="col-xl">
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="nomorLambung"
                            >NOMOR LAMBUNG
                        </label>
                        <div class="col-sm-7 ">
                            <span
                            class=" form-control-plaintext "
                        >
                            {{ sarana.noLambung }}
                            </span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="noPol"
                            >NOMOR POLISI</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.noPol }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="merek">MEREK</label>
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.merek }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="type">TYPE</label>
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.type }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="noMesin"
                            >NOMOR MESIN</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.noMesin }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="warna">WARNA</label>
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.warna }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="thnPembuatan"
                            >TAHUN PEMBUATAN</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.thnPembuatan }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="pajak"
                            >MASA BERLAKU PAJAK</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ moment(sarana.pajak).format("DD MMMM YYYY") }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="kir"
                            >MASA BERAKHIR KIR</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ moment(sarana.kir).format("DD MMMM YYYY") }}</span>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="stnk"
                            >MASA BERLAKU STNK</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ moment(sarana.stnk).format("DD MMMM YYYY") }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="serahTerima"
                            >TANGGAL SERAH TERIMA</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ moment(sarana.serahTerima).format("DD MMMM YYYY") }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="kontrak"
                            >TANGGAL KONTRAK BERAKHIR</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ moment(sarana.kontrak).format("DD MMMM YYYY") }}</span>
                        </div>
                    </div>
                    <!-- <div class="mb-3"> -->
                    <!-- <label class="form-label" for="sewa">BIAYA SEWA</label> -->
                   
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.sewa }}</span>
                        </div>
                    <!-- </div> -->

                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="pemilik"
                            >NAMA PEMILIK</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.pemilik }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="pic"
                            >PERSON IN CHARGE (PIC)</label
                        >
                        <div class="col-sm-7 ">
                        <span
                            class="form-control-plaintext"
                            >{{ sarana.pic }}</span>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <label class="col-sm-5 col-form-label" for="status">STATUS</label>
                        <span class="col-sm-7 form-control-plaintext-plaintext">
                            <div class="form-check form-switch mb-2">
                                <input
                                    @change="chgStatus"
                                    class="form-check-input"
                                    type="checkbox"
                                    id="status"
                                    v-model="chkStatus"
                                    disabled="disabled"
                                />
                                <label class="form-check-label" for="status"
                                    >Aktif</label
                                >
                            </div>
                        </span>
                    </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    mounted() {
        this.initDatas();
    },
    data() {
        return {
            moment: moment,
            strTime:new Date(),
            urlAction: "/",
            csrfTokens: "",
            sarana: {},
            eSarana: {},
            chkStatus: true,
            idVehicles: null,
        };
    },
    props: ["tokens", "url_action"],
    methods: {
        send() {
            this.idVehicles != null
                ? this.updateAPI(this.idVehicles)
                : this.save();
        },
        save() {
            axios.post("/sarana/lv", this.sarana).then((response) => {
                var data = response.data;
                if (data.success) {
                    $("#myToast").toast("show");
                    $("#dismisBtn").click();
                    this.initDatas();
                    this.updateData();
                }
            });
        },
        updateAPI(id) {
            axios.put("/sarana/lv/" + id, this.sarana).then((response) => {
                var data = response.data;
                if (data.success) {
                    $("#myToast").toast("show");
                    $("#dismisBtn").click();
                    this.initDatas();
                    this.updateData();
                }
            });
        },
        getByIds(id) {
            this.initDatas();
            this.idVehicles = id;
            axios
                .get("/sarana/lv/" + this.idVehicles + "/edit")
                .then((response) => {
                    var v = response.data;
                    if (v != null) {
                        var s = {};
                        s.noLambung = v.noLambung;
                        s.noPol = v.noPol;
                        s.pic = v.pic;
                        s.merek = v.merek;
                        s.type = v.type;
                        s.kontrak = v.kontrak;
                        s.sewa = v.sewa;
                        s.status = v.status;
                        s.uidVehicle = v.uidVehicle;
                        s.slug = v.slug;

                        s.noMesin = v.detail.noMesin;
                        s.warna = v.detail.warna;
                        s.thnPembuatan = v.detail.thnPembuatan;
                        s.pajak = v.detail.pajak;
                        s.kir = v.detail.kir;
                        s.stnk = v.detail.stnk;
                        s.pemilik = v.detail.pemilik;
                        s.serahTerima = v.detail.serahTerima;
                        this.sarana = s;
                    }
                });
        },
        getUid() {
            axios.get("/get/uids").then((response) => {
                this.sarana.uidVehicle = response.data;
            });
        },

        updateData() {
            this.$emit("tabelSaranaEmit");
        },
        focusInputs() {
            this.$refs.noLambung.focus();
        },

        chgStatus() {
            this.chkStatus != this.chkStatus;
            if (this.chkStatus) {
                this.sarana.status = 1;
            } else {
                this.sarana.status = 0;
            }
        },
        initDatas() {
            this.sarana = {};
            if (this.url_action != null) {
                this.urlAction = this.url_action;
            }
            if (this.tokens != null) {
                this.csrfTokens = this.tokens;
            }
            this.sarana.status = 1;
            this.sarana.thnPembuatan = new Date().getFullYear();
            this.getUid();
        },
    },
    expose: ["initDatas", "getByIds", "focusInputs"],
};
</script>
